// import { Issue } from '@api/module/management/learning-scheme/model/Issue'
import { ResponseStatus } from '@api/Response'
import SyllabusModule from '@api/module/customer/syllabus/SyllabusModule'
import LearningSchemeModule from '@api/module/customer/myscheme/LearningSchemeModule'
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import {
  EffectiveLSAndCommoditySkuResponse,
  UserPreExamLSResponse,
  UserPreExamLSIssueResponse,
  PreExamLSResponse,
  StudentIdentityResponse
} from '@api/gateway/PreExamLS-default'
import store from '@/store'
import UserModule from '@api/module/customer/user/UserModule'
import { cloneDeep } from 'lodash'
import { PracticeLearningUi, UserIssueUi } from './modelUi'
import Industry from '@api/model/syllabus/Industry'
import Major from '@api/model/syllabus/Major'
import Effectiveness, { IssueEffectivenessCode } from '@api/model/myscheme/Effectiveness'
import moment from 'moment'
import RootModule from '@/common/store/RootModule'
import IndustryRelationModule from '@api/module/common/tag/industry/IndustryRelationModule'
import IndustryRelationCustomerModule from '@api/module/customer/tag/industry/IndustryRelationCustomerModule'
/**
 * 暴露给外部
 */
export * from './modelUi'
export enum LoadStatus {
  UNLOAD = 'unload',
  LOADING = 'loading',
  FAIL = 'fail',
  SUCCESS = 'success'
}

// 试题练习

@Module({ namespaced: true, dynamic: true, name: 'CurrentSchemeModule', store })
class CurrentSchemeModule extends VuexModule {
  // 选中的行业，用来控制选择样式
  currentIndustryMajor = {
    industryId: '',
    majorId: ''
  }

  /**加载的时候不能点击专业 */
  selectMajorLoading = false
  /**
   * 当前方案有效的期别信息
   */
  mySchemeEffectiveIssue: UserPreExamLSIssueResponse = new UserPreExamLSIssueResponse()
  /**
   * 当前培训班下默认的账号有效期
   */
  mySchemeStudentityIdentity: StudentIdentityResponse = new StudentIdentityResponse()

  majorList = new Array<Major>()
  /**
   * 已报名班级的行业/专业信息
   */
  myLearningSchemeIndustryList: Array<Industry> = new Array<Industry>()
  /***
   * 当前选择期别
   */
  // currentUserIssue: PreExamLSResponse | EffectiveLSAndCommoditySkuResponse = new PreExamLSResponse()
  /***
   * 当前选择的方案
   */
  // new UserPreExamLSResponse() as UserPreExamLSResponse &
  //   EffectiveLSAndCommoditySkuResponse
  currentUserScheme: UserIssueUi = new UserIssueUi()

  /**
   * 加载用户期别信息的状态
   */
  loadIssueStatus: LoadStatus = LoadStatus.UNLOAD

  /**
   * 我的培训班下期数列表
   */
  mySchemeIssueList: Array<UserPreExamLSIssueResponse> = new Array<UserPreExamLSIssueResponse>()
  /**
   * 期数是否有效信息
   */
  issueEffectiveInfo = new Effectiveness()
  /**
   * 我的培训班下有效期列表
   */
  mySchemeStudentityIdentityList: Array<StudentIdentityResponse> = new Array<StudentIdentityResponse>()

  /**
   * 选中的期数
   */
  currentUserSchemeIssue: UserPreExamLSIssueResponse = new UserPreExamLSIssueResponse()
  /**
   * 选中的有效期
   */
  currentUserSchemeIdentity: StudentIdentityResponse = new StudentIdentityResponse()

  /**
   * 初始化或变更我报名班级所属的行业专业信息
   * @param ctx 状态
   */
  @Action
  initOrChangeIndustryOfMine(): Promise<ResponseStatus> {
    const industryList: Array<any> = new Array<any>()
    // todo wengpengfei
    const industryAll = IndustryRelationCustomerModule.industryRelationList
    // 分析出用户期别的行业/专业信息
    const industryIdData = new Map()
    const majorIdData = new Map()
    // todo wengpengfei
    const LearningSchemeList = LearningSchemeModule.getAllLearningScheme
    for (const scheme of LearningSchemeList) {
      industryIdData.set(scheme.examTypeId, scheme.examTypeId)
      majorIdData.set(scheme.professionId, scheme.professionId)
    }
    for (const industry of industryAll) {
      const newIndustry = JSON.parse('{ "id": "", "name": "", "majorList": [] }')
      if (industryIdData.get(industry.id)) {
        // 存在
        newIndustry.id = industry.id
        newIndustry.name = industry.name
        for (const major of industry.majorList) {
          if (majorIdData.get(major.id)) {
            // 存在专业
            const newMajor = JSON.parse('{ "id": "", "name": "" }')
            newMajor.id = major.id
            newMajor.name = major.name
            if (newIndustry.majorList.findIndex((item: any) => item.id === newMajor.id) < 0) {
              newIndustry.majorList.push(newMajor)
            }
          }
        }
        if (newIndustry.majorList.length > 0 && industryList.findIndex(item => item.id === newIndustry.id) < 0) {
          industryList.push(newIndustry)
        }
      }
    }
    this.SET_MY_LEARNING_SCHEME_INDUSTRY_LIST({ industryList: industryList })
    return Promise.resolve(new ResponseStatus(200, ''))
  }

  /**
   * 销毁我报名班级所属的行业专业信息
   * @param ctx 状态
   */
  @Action
  destroyIndustryOfMine(): Promise<ResponseStatus> {
    this.SET_MY_LEARNING_SCHEME_INDUSTRY_LIST({ industryList: [] })
    return Promise.resolve(new ResponseStatus(200, ''))
  }

  /**
   * 初始化或变更我当前查看的学习方案
   * @param ctx 状态
   * @param params 参数：industryId - 行业编号；majorId - 专业编号
   */
  @Action
  async initOrChangeCurrentScheme(params: { industryId: string; majorId: string }): Promise<ResponseStatus> {
    const schemeList = cloneDeep(
      LearningSchemeModule.getLearningSchemeByIndustryIdAndMajorId(params.industryId, params.majorId)
    )
    if (!schemeList || schemeList.length === 0) {
      return Promise.resolve(new ResponseStatus(500, '没有学习方案'))
    }
    const scheme = schemeList[0]
    const res = await this.setScheme(scheme)
    return res ? res : Promise.resolve(new ResponseStatus(200, ''))
  }

  @Action
  setMajorList(index: number) {
    this.SET_MAJOR_LIST(index)
  }
  /**
   * 销毁我当前查看的班级期数
   * @param ctx 状态
   */
  @Action
  destroyCurrentIssue(): Promise<ResponseStatus> {
    // this.SET_CURRENT_USER_ISSUE(new PreExamLSResponse())
    this.SET_CURRENT_SCHEME(new UserIssueUi())
    this.SET_CURRENT_SCHEME_IDENTITY(new StudentIdentityResponse())
    this.SET_CURRENT_SCHEME_ISSUE(new UserPreExamLSIssueResponse())
    return Promise.resolve(new ResponseStatus(200, ''))
  }

  @Action
  setLoadIssueStatus(status: LoadStatus): Promise<ResponseStatus> {
    this.SET_LOADISSUE_STATUS({ status: status })
    return Promise.resolve(new ResponseStatus(200, ''))
  }

  /**
   * 处理方案变换
   * **/
  @Action
  async setScheme(scheme: UserPreExamLSResponse) {
    this.SELECT_MAJOR_LOADING(true)
    this.SET_CURRENT_INDUSTRY_MAJOR({ industryId: scheme.examTypeId, majorId: scheme.professionId })
    // 判断是期别还是有效期模式
    let res
    if (scheme?.trainingForm === 'EFFECTIVE') {
      // 有效期
      // 获取对应的详情
      res = await LearningSchemeModule.findEffectiveLSById(scheme.schemeId)
      if (!res.isSuccess()) {
        this.SELECT_MAJOR_LOADING(false)
        return res
      }
      await LearningSchemeModule.findStudentIdentityListByCurrentUser(scheme.schemeId)
      this.SET_MYSCHEME_IDENTITY_LIST(cloneDeep(LearningSchemeModule.mySchemeStudentityIdentityList))
      // const currentIdentityIssueId = localStorage.getItem('currentIdentity')
      let currentUserScheme = await CurrentSchemeModule.toUserIssue(
        LearningSchemeModule.effectiveLearningSchemeDetailDTO as any
      )
      // 缓存默认选中
      res = await this.findEffectiveStudentIdentityByCurrentUser(scheme.schemeId)
      currentUserScheme = await CurrentSchemeModule.toUserIssue(
        LearningSchemeModule.effectiveLearningSchemeDetailDTO as any
      )
      if (!res.isSuccess()) {
        this.SELECT_MAJOR_LOADING(false)
        return res
      }
      this.SET_CURRENT_SCHEME(currentUserScheme as any)
      this.SET_CURRENT_SCHEME_IDENTITY(cloneDeep(this.mySchemeStudentityIdentity))
    }
    // else if (scheme?.trainingForm === 'ISSUE')
    else {
      // 返回日期最近的
      res = await LearningSchemeModule.findIssueLSById(scheme.schemeId)
      if (!res.isSuccess()) {
        this.SELECT_MAJOR_LOADING(false)
        return res
      }
      res = await LearningSchemeModule.findIssueListByCurrentUser(scheme.schemeId)
      this.SET_MYSCHEME_ISSUE_LIST(LearningSchemeModule.mySchemeIssueList)
      if (!res.isSuccess()) {
        this.SELECT_MAJOR_LOADING(false)
        return res
      }
      res = await LearningSchemeModule.findEffectiveIssueByCurrentUser(scheme.schemeId)
      if (!res.isSuccess()) {
        this.SELECT_MAJOR_LOADING(false)
        return res
      }
      let currentUserScheme = await CurrentSchemeModule.toUserIssue(
        LearningSchemeModule.issueLearningSchemeDetailDTO as any
      )

      currentUserScheme = await CurrentSchemeModule.toUserIssue(
        LearningSchemeModule.issueLearningSchemeDetailDTO as any
      )
      this.SET_CURRENT_SCHEME(currentUserScheme as any)
      this.SET_CURRENT_SCHEME_ISSUE(cloneDeep(LearningSchemeModule.mySchemeEffectiveIssue))
      /**设置缓存 */
      this.setDefaultIssueEffectiveId({
        schemeId: this.currentUserSchemeIssue.schemeId,
        issueId: this.currentUserSchemeIssue.issueId,
        userId: this.currentUserSchemeIssue.userId
      })
    }
    this.SELECT_MAJOR_LOADING(false)
    return res
  }

  /**
   * 设置默认有效期
   */
  @Action
  async setDefaultIssueEffective(identityId: string) {
    await this.setDefaultIssueEffectiveId({
      schemeId: this.currentUserScheme.schemeId,
      issueId: this.issueInfo.issueId,
      userId: identityId
    })

    const res = await this.checkoutCurrentIdentity(identityId)

    // res = await this.findEffectiveStudentIdentityByCurrentUser(this.currentUserScheme.schemeId)
    return res
  }

  @Action
  rest() {
    this.REST()
    LearningSchemeModule.restData()
  }
  /**
   * 读取默认期别/账号有效期Id
   */
  @Action
  async getDefaultIssueEffective(schemeId: string) {
    // const responseStatus = UserModule.userInfo.userId
    // if (!responseStatus.isSuccess()) {
    //   return { issueId: '', userId: '' }
    // }
    if (UserModule.userInfo && UserModule.userInfo.userId) {
      const value = localStorage.getItem(schemeId + '_' + UserModule.userInfo.userId)

      if (value) {
        const values = value.split('_')
        return { issueId: values[0], userId: values[1] }
      }
    }
    return { issueId: '', userId: '' }
  }

  /**
   * 获取默认选中的有效期
   */
  @Action
  async findEffectiveStudentIdentityByCurrentUser(schemeId: string) {
    if (!LearningSchemeModule.mySchemeStudentityIdentityList) {
      await LearningSchemeModule.findStudentIdentityListByCurrentUser(schemeId)
      this.SET_MYSCHEME_IDENTITY_LIST(cloneDeep(LearningSchemeModule.mySchemeStudentityIdentityList))
    }
    const { issueId, userId } = await this.getDefaultIssueEffective(schemeId)
    const mySchemeStudentityIdentityList = this.mySchemeStudentityIdentityList.filter(el => {
      return el.expired === false
    })

    // 当默认的过期了且没有新的有效期后才会继续该有效期。 否则取最新的有效有效期
    // 过期的同时没有新的有效期 取默认
    // 默认没有过期取默认
    //
    for (const mySchemeStudentityIdentity of this.mySchemeStudentityIdentityList) {
      if (
        issueId &&
        userId &&
        issueId === mySchemeStudentityIdentity.issueId &&
        userId === mySchemeStudentityIdentity.id
      ) {
        // 没过期的情况都可以赋值
        // 过期了 只有没有可用列表才能赋值
        if (
          !mySchemeStudentityIdentity.expired ||
          (mySchemeStudentityIdentity.expired && mySchemeStudentityIdentityList.length === 0)
        ) {
          this.SET_MY_SCHEME_EFFECTIVE_STUDENT_IDENTITY(mySchemeStudentityIdentity)
          return new ResponseStatus(200, '')
        }
      }
    }
    // 拿未过期的第一个。 如果都过期了拿所有有效期的第一个
    if (mySchemeStudentityIdentityList && mySchemeStudentityIdentityList.length > 0) {
      this.setDefaultIssueEffectiveId({
        schemeId: mySchemeStudentityIdentityList[0].schemeId,
        issueId: mySchemeStudentityIdentityList[0].issueId,
        userId: mySchemeStudentityIdentityList[0].id
      })
      this.SET_MY_SCHEME_EFFECTIVE_STUDENT_IDENTITY(mySchemeStudentityIdentityList[0])
    } else if (mySchemeStudentityIdentityList.length === 0) {
      this.setDefaultIssueEffectiveId({
        schemeId: this.mySchemeStudentityIdentityList[0].schemeId,
        issueId: this.mySchemeStudentityIdentityList[0].issueId,
        userId: this.mySchemeStudentityIdentityList[0].id
      })
      this.SET_MY_SCHEME_EFFECTIVE_STUDENT_IDENTITY(this.mySchemeStudentityIdentityList[0])
    }
    return new ResponseStatus(200, '')
  }

  /**
   * 变更选中的有效期
   */
  @Action
  checkoutCurrentIdentity(identityId: string) {
    const currentIdentity = this.mySchemeStudentityIdentityList.filter(item => {
      return item.id === identityId
    })
    if (currentIdentity.length > 0) {
      this.SET_CURRENT_SCHEME_IDENTITY(currentIdentity[0])
      return Promise.resolve(new ResponseStatus(200, ''))
    } else {
      return Promise.resolve(new ResponseStatus(500, '当前有效期无效'))
    }
  }

  /**
   *
   * @param issueInfo.id 指账号期别的身份ID
   */
  @Action
  async validUserIssue(issueInfo?: {
    trainingForm: string
    issueId: string
    userId: string
    id: string
    expired: boolean
  }) {
    const info = issueInfo || this.issueInfo
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let res
    const trainingForm = issueInfo ? issueInfo.trainingForm : this.currentUserScheme.trainingForm
    // 先验证账号有效期是否过期
    if (trainingForm === 'EFFECTIVE') {
      res = await LearningSchemeModule.validUserIssue({ issueId: info.issueId, userId: info.id })
    } else {
      res = await LearningSchemeModule.validUserIssue({ issueId: info.issueId, userId: info.userId })
    }
    this.SET_ISSUE_EFFECTIVE_INFO({
      issueId: info.issueId,
      code: LearningSchemeModule.issueEffectiveInfo.code,
      message: CurrentSchemeModule.validateTip(
        LearningSchemeModule.issueEffectiveInfo.code,
        trainingForm === 'ISSUE',
        LearningSchemeModule.issueEffectiveInfo.message
      )
    })

    return res
  }

  @Mutation
  SET_ISSUE_EFFECTIVE_INFO(params: { issueId: string; code: string; message: string }) {
    this.issueEffectiveInfo = new Effectiveness()
    this.issueEffectiveInfo.issueId = params.issueId
    this.issueEffectiveInfo.isEffective = params.code === IssueEffectivenessCode.EFFECTIVE
    this.issueEffectiveInfo.code = params.code as IssueEffectivenessCode
    this.issueEffectiveInfo.message = params.message
  }
  /**
   * 设置已报名班级的行业/专业信息
   */
  @Mutation
  SET_MY_LEARNING_SCHEME_INDUSTRY_LIST(params: { industryList: Array<any> }) {
    this.myLearningSchemeIndustryList = params.industryList
  }

  /**
   * 设置当前选中的期别/有效期信息(期别/有效期)
   */
  // @Mutation
  // SET_CURRENT_USER_ISSUE(detail: EffectiveLSAndCommoditySkuResponse | PreExamLSResponse) {
  //   this.currentUserIssue = detail
  // }

  /**
   * 当前方案有效的期别信息
   */
  @Mutation
  private SET_MY_SCHEME_EFFECTIVE_ISSUE(mySchemeEffectiveIssue: UserPreExamLSIssueResponse) {
    this.mySchemeEffectiveIssue = mySchemeEffectiveIssue
  }

  /**设置专业列表 */
  @Mutation
  SET_MAJOR_LIST(index: number) {
    this.majorList = [...this.myLearningSchemeIndustryList[index].majorList]
  }
  /**
   * 设置加载数据状态
   */
  @Mutation
  SET_LOADISSUE_STATUS(params: { status: LoadStatus }) {
    this.loadIssueStatus = params.status
  }

  /**
   * 设置当前的学习方案
   */

  @Mutation
  SET_CURRENT_SCHEME(scheme: any) {
    this.currentUserScheme = cloneDeep(scheme)
  }

  @Mutation
  SET_CURRENT_INDUSTRY_MAJOR(param: { industryId: string; majorId: string }) {
    this.currentIndustryMajor = {
      industryId: param.industryId,
      majorId: param.majorId
    }
  }
  /**
   * 设置当前的学习方案期数
   */
  @Mutation
  SET_CURRENT_SCHEME_ISSUE(userPreExamLSIssueResponse: UserPreExamLSIssueResponse) {
    this.currentUserSchemeIssue = userPreExamLSIssueResponse
  }
  /**
   * 设置当前的学习方案有效期
   */
  @Mutation
  SET_CURRENT_SCHEME_IDENTITY(studentIdentityResponse: StudentIdentityResponse) {
    this.currentUserSchemeIdentity = studentIdentityResponse
  }
  /***
   * 当前学习方案期数的列表
   */
  @Mutation
  SET_MYSCHEME_ISSUE_LIST(schemeIssueList: UserPreExamLSIssueResponse[]) {
    this.mySchemeIssueList = schemeIssueList
  }

  /***
   * 当前学习方案有效期的列表
   */
  @Mutation
  SET_MYSCHEME_IDENTITY_LIST(schemeIdentityList: StudentIdentityResponse[]) {
    this.mySchemeStudentityIdentityList = schemeIdentityList
  }
  /**
   * 当前方案默认的账号有效期信息
   */
  @Mutation
  private SET_MY_SCHEME_EFFECTIVE_STUDENT_IDENTITY(mySchemeStudentityIdentity: StudentIdentityResponse) {
    this.mySchemeStudentityIdentity = cloneDeep(mySchemeStudentityIdentity)
  }

  @Mutation
  REST() {
    this.currentUserScheme = new UserIssueUi()
    this.currentUserSchemeIdentity = new StudentIdentityResponse()
    this.currentUserSchemeIssue = new UserPreExamLSIssueResponse()
  }

  @Mutation
  SELECT_MAJOR_LOADING(val: boolean) {
    this.selectMajorLoading = val
  }
  /**
   * 缓存默认期别/账号有效期Id
   */
  @Action
  async setDefaultIssueEffectiveId(params: { schemeId: string; issueId: string; userId: string }) {
    const responseStatus = await UserModule.queryUserInfo()
    if (!responseStatus.isSuccess()) {
      return
    }
    localStorage.setItem(params.schemeId + '_' + UserModule.userInfo.userId, params.issueId + '_' + params.userId)
  }

  // @Action
  // async changeScheme(scheme: UserPreExamLSResponse) {
  //   await this.setScheme(scheme)
  // }

  /**
   * 获取当前选中的方案信息
   * @param state 状态
   */
  get getCurrentScheme() {
    return this.currentUserScheme
  }

  /**
   * 选择方案下的选择的期别/有效期信息
   */
  get issueInfo(): StudentIdentityResponse & UserPreExamLSIssueResponse {
    if (this.currentUserScheme?.trainingForm === 'EFFECTIVE') {
      return this.currentUserSchemeIdentity as StudentIdentityResponse & UserPreExamLSIssueResponse
    } else {
      return this.currentUserSchemeIssue as StudentIdentityResponse & UserPreExamLSIssueResponse
    }
  }

  /**
   * 唯一标识id 用来全局监听变化去请求刷新 减少请求数
   */
  get issueFlagId(): string {
    if (!this.issueInfo.schemeId || !this.issueInfo.issueId) {
      return ''
    }

    return (
      this.issueInfo.schemeId +
      this.issueInfo.issueId +
      (this.currentUserScheme.trainingForm === 'ISSUE' ? this.issueInfo.userId : this.issueInfo.id)
    )
  }

  get getCurrentUserSchemeIdentity() {
    return this.currentUserSchemeIdentity
  }

  get getCurrentUserSchemeIssue() {
    return this.currentUserSchemeIssue
  }
  /**
   * 存在未报班
   */
  get isEmptyIssue(): boolean {
    if (!this.issueInfo || !this.issueInfo.issueId) {
      return true
    } else {
      return false
    }
  }

  /**
   * 获取有效期l列表 新增默认字段 check 选中即默认
   */
  get getSchemeStudentityIdentityList(): StudentIdentityResponse & { check: boolean }[] {
    let list = [...LearningSchemeModule.getSchemeStudentityIdentityList]
    // 当前默认的固定排第一位
    const value = localStorage.getItem(this.currentUserScheme.schemeId + '_' + UserModule.userInfo.userId)

    if (value) {
      const values = value.split('_')
      const id = values[1]
      const index = list.findIndex(val => {
        return val.id === id
      })
      const defaultStudentityIdentity = { ...list[index] }
      list.splice(index, 1)
      list.unshift(defaultStudentityIdentity)
      list = list.filter(identity => {
        return !identity.expired
      })
    }

    const newList = list?.map(item => {
      let check = false
      if (item.id === this.mySchemeStudentityIdentity.id) {
        check = true
      }
      item = Object.assign(item, {
        check: check
      })
      return item
    })
    return (newList as unknown) as StudentIdentityResponse & { check: boolean }[]
  }
  // @Mutation
  // SET_IDENTITY_DEFAULT(issueId: string) {}

  /**
   * 获取开始结束时间
   */
  get startTime() {
    if (this.currentUserScheme.trainingForm === 'EFFECTIVE') {
      return new Date(this.issueInfo.effectiveDate)
    } else {
      return new Date(this.issueInfo.startTime)
    }
  }

  get endTime() {
    if (this.currentUserScheme.trainingForm === 'EFFECTIVE') {
      return new Date(this.issueInfo.expireDate)
    } else {
      return new Date(this.issueInfo.endTime)
    }
  }

  /**
   * 真实的身份id。 用来代替userid  这个在明确在状态层有保存数据的时候如学员中心页面（这个时候使用了major这个组件。回去自动加载状态层数据）
   * 时候使用。 如果是在课程选课等刷新后不一定加载状态层数据的网页时请使用
   * getDefaultIssueEffective.。
   */
  get realIdentityId() {
    if (this.currentUserScheme?.trainingForm === 'EFFECTIVE' && this.currentUserSchemeIdentity?.id) {
      return this.currentUserSchemeIdentity.id
    } else if (this.currentUserScheme?.trainingForm === 'ISSUE' && this.currentUserScheme) {
      return this.currentUserSchemeIssue.userId
    } else {
      return ''
    }
  }

  get getMySchemeStudentityIdentity() {
    return this.mySchemeStudentityIdentity
  }

  // get majorList() {
  //   return this.myLearningSchemeIndustryList[0].majorList
  // }

  get date() {
    return RootModule.getCurrentSystemTimeDate()
  }

  /**
   * 距离线下考试时间 - 期别
   */
  get offlineExamTimeDiff() {
    // const diff = CurrentSchemeModule.diffDay(moment(this.issueInfo.offlineExamTime), this.date)
    // return diff > 0 ? diff : '考试已开始'
    return this.issueInfo.remainOfflineExamDay
  }
  /**
   * 期别的情况下过期
   */
  get issueOverdue() {
    const diff = CurrentSchemeModule.diffDay(moment(this.issueInfo.offlineExamTime), this.date)
    return diff <= 0
  }
  /**
   * 账号剩余天数
   */
  get remainingDays() {
    // return this.issueInfo.expired
    //   ? '账号已到期'
    //   : CurrentSchemeModule.diffDay(
    //       moment(this.expireDate).format('YYYY-MM-DD'),
    //       moment(this.date as any).format('YYYY-MM-DD')
    //     ) + 1
    return this.issueInfo.remainEffectiveDay
  }

  static diffDay(end: any, start: any) {
    return moment(CurrentSchemeModule.getTimeToYMD(end)).diff(CurrentSchemeModule.getTimeToYMD(start), 'days')
  }

  /**
   * 过期日期
   */
  get expireDate() {
    return this.issueInfo.expireDate
  }

  /**
   * 转化成年月日
   * **/
  static getTimeToYMD(date: string | Date) {
    return moment(date).format('YYYY-MM-DD')
  }

  /** 过期提醒  isIssue 是不是期别: */
  static validateTip(code: IssueEffectivenessCode, isIssue: boolean, defaultMessage: string) {
    // const msg = isIssue ? '当前考试期别' : '当前账号有效期'
    let result = ''

    if (code != IssueEffectivenessCode.EFFECTIVE && !isIssue) {
      return (result = `当前帐号有效期已过期，不能进入placeholder`)
    }
    switch (code) {
      // placeholder 占位符
      case IssueEffectivenessCode.EFFECTIVE:
        //有效
        break
      case IssueEffectivenessCode.INVALID:
        result = `当前考试期别已退款，不能进入placeholder！`
        break
      case IssueEffectivenessCode.EXPIRED:
        result = `当前考试期别学习有效期已过，不能进入placeholder！`
        break
      case IssueEffectivenessCode.REFUND_FROZEN:
        result = `当前考试期别申请退款中，不能进入placeholder！`
        break
      case IssueEffectivenessCode.ISSUE_NOT_START_TRAINING:
        result = `当前考试期别学习未开始培训，不能进入placeholder！`
        break

      default:
        result = `${defaultMessage}，不能进入placeholder！`
        break
    }
    return result
  }
  /**
   * 转成对应给UI的模型
   * 背景：端口改过第二版，防止UI爆炸。。
   *
   * @param detail 学习方案的详情 参数用&处理 保证能追踪到
   * @param issue 对应的期别/有效期详情applyExamOutlinePracticeLearningToken
   */
  static async toUserIssue(detail: PreExamLSResponse & EffectiveLSAndCommoditySkuResponse): Promise<UserIssueUi> {
    const obj: UserIssueUi = new UserIssueUi()
    obj.industryId = detail?.examTypeId
    obj.majorId = detail?.professionId
    obj.issueId = detail?.issueId
    obj.newEffectiveCommoditySkuId = detail?.newEffectiveCommoditySkuId
    obj.resitEffectiveCommoditySkuId = detail?.resitEffectiveCommoditySkuId
    obj.validDay = detail?.validDay
    obj.openEnrolment = detail?.openEnrolment
    obj.upDownSettings = detail?.upDownSettings
    obj.schemeId = detail?.schemeId
    obj.schemeName = detail?.name
    obj.year = detail?.year
    obj.trainingForm = detail?.trainingForm
    obj.createUserId = detail?.createUserId
    obj.createTime = detail?.createTime
    obj.examLearning = detail?.examLearning
    obj.learningId = detail?.courseLearning.learningId
    obj.courseLearning = detail?.courseLearning
    obj.practiceLearning = new PracticeLearningUi()
    obj.practiceLearning.learningId = detail?.questionPracticeLearning?.learningId
    obj.practiceLearning.dailyExamination = detail?.dailyExamination
    obj.practiceLearning.errorPronePractice = detail?.errorPronePractice
    obj.practiceLearning.questionPractice = detail?.questionPracticeLearning
    obj.picture = detail?.picture ? '/mfs/' + detail?.picture : ''
    obj.syllabusId = detail?.syllabusId
    obj.presentationStructure = detail?.presentationStructure
    // if (detail.trainingForm === 'ISSUE') {
    //   await LearningSchemeModule.validUserIssue({
    //     issueId: obj.issueId,
    //     userId: UserModule.userInfo.userId
    //   })
    //   obj.effetiveness = LearningSchemeModule.issueEffectiveInfo
    // }
    return obj
  }
}

export default getModule(CurrentSchemeModule)
